<template>
	<div>
		<a-upload name="file" :disabled="disabled" :headers="headers" :action="uploadPath" :beforeUpload="beforeUpload" :showUploadList="false" :data="params" @change="handleChange">
			<a-button v-if="isDisplay" :disabled="disabled">
				<a-icon :type="loading ? 'loading' : 'upload'" />{{buttonName}}
			</a-button>
		</a-upload>
		<div>
			<div class="uploadFrame" v-for="(item,index) in fileArr" :key="index">
				<a-icon style="font-size: 13px;" type="link" />
				<span>{{item.fileFullName}}</span>
				<a-icon class="close" type="close" @click="remove(item)" v-if="isDisplay && !disabled"/>
				<a-icon class="close" type="download" @click="download(item)" v-if="whetherDownload"/>
			</div>
		</div>
	</div>
</template>

<script>
	import {privateUploadPath} from '@/utils/fileSetting';

	export default {
		name: 'UploadFile',
		props: {
			size:{
				type: Number,
				default:200
			},
			params: {
				type: Object,
			},
			defaultFileList: {
				type: Array
			},
			isDisplay:{
				type:Boolean,
				default:true
			},
			buttonName: {
				default: '上传'
			},
			whetherDownload: {
				type: Boolean,
				default: false
			},
			disabled: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			fileArr: {
				get: function(){
					return this.defaultFileList;
				},
				set: function(){

				}
			}
		},
		data() {
			return {
				loading: false,
				headers: {
					Authentication: this.$store.state.account.token
				},
				uploadPath: privateUploadPath,
			}
		},
		methods: {
			handleChange (info) {
				if (info.file.status === undefined) {
					info.fileList.pop();
					return;
		      	}
		      	if (info.file.status === 'uploading') {
		        	this.loading = true
		        	return
		      	}
		      	if (info.file.status === 'done') {
		      		let response = info.file.response;
		      		this.fileArr.unshift(response)
		      		this.loading = false;
		      		this.$message.success("上传成功");
		      	}
		    },
		    beforeUpload (file) {
		      	const limitSize = file.size / 1024 / 1024 < this.size
		      	if (!limitSize) {
			        this.$message.error('文件必须小于'+this.size+'M!')
		      	}
		      	return limitSize;
		    },
		    remove(item){
		    	this.fileArr.splice(this.fileArr.indexOf(item), 1);
		    },
			download(item){
				this.$download(`file/downloadFile/${item.id}`,{}, item.fileFullName);
			}
		}
	}
</script>

<style lang="less" scoped>
	.uploadFrame{
		width: 100%;
		position: relative;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		height: 30px;
		line-height: 30px;
		padding:0 20px 0 5px;
		cursor: pointer;
		.close{
			position: absolute;
			top:10px;
			right: 5px;
			font-size: 13px;
			color: #7E888C;
			display: none;
		}
		.close:hover{
			color: #393939;
		}
	}
	.uploadFrame:hover{
		background: #E6F7FF;
		display: block;
	}
	.uploadFrame:hover>.close{
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/views/common/UploadFile.vue